import React, {Component, Fragment} from 'react';
import {Button, Label, FormGroup, Form, Input} from 'reactstrap';
import Dialog from 'apa/containers/Dialog';
import {connect} from 'react-redux';
import {create} from 'catalog/actions/attachments'

import autobind from 'autobind-decorator';
import Loading from 'apa/components/Loading';


@connect(
    null,
    dispatch => ({
            add: (attachment, callback) => dispatch(create(attachment, callback))
    })
)
export default class NewAttachment extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isOpen: false,
            uploading: false,
            fileSet: false,
            filename: '',
            attachment: ''
        };
    }

    @autobind
    toggle() {
        this.setState({
            isOpen: !this.state.isOpen,
        })
    }

    @autobind
    setNewAttachment(e) {
        const attachment = e.target.files[0];
        const data = new FormData();
        data.append('measure_id', this.props.measure.id);
        data.append('file', attachment);
        data.append('filename', attachment.name);
        this.setState({
            fileSet: true,
            filename: attachment.name,
            attachment: data
        });
    }

    @autobind
    confirm() {
        this.setState({uploading: true})
        this.props.add(this.state.attachment, () => this.setState({uploading: false, isOpen: false, attachment: '', fileSet: false}))
    }

    render() {
        return (
            <Fragment>
                <Button color='primary' size={'sm'} onClick={this.toggle}>
                    <i className='fa fa-plus'> </i> Anhang hinzufügen
                </Button>
                <Dialog
                    isOpen={this.state.isOpen}
                    toggle={this.toggle}
                    confirm={this.confirm}
                    title="Neue Kategorie anlegen"
                >
                    <Form>
                        <FormGroup>
                            <Label for="parent">Anhang</Label>
                            {!this.state.fileSet &&
                            <Input
                                type="file"
                                value={this.state.attachment}
                                onChange={this.setNewAttachment}
                            />
                            }
                            {this.state.fileSet &&

                            <Fragment>
                                {
                                    !this.state.uploading &&
                                    this.state.filename
                                }
                                {
                                    this.state.uploading &&
                                    <Loading/>
                                }
                            </Fragment>
                            }
                        </FormGroup>
                    </Form>
                </Dialog>
            </Fragment>
        )
    }
}


